/* OwnReview.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _9 = "._1bsb1osq{width:100%}";
const _8 = "._11q71j9a{background:var(--ds-background-input,#fff)}";
const _7 = "._2rko1kwk{border-radius:.5rem}";
const _6 = "._1yt4pxbi{padding:var(--ds-space-200,1pc)}";
const _5 = "._otyr1jfw{margin-bottom:var(--ds-space-500,40px)}";
const _4 = "._11q7m7j4{background:var(--ds-background-neutral,#091e420f)}";
const _3 = "._2rkooqnp{border-radius:.75rem}";
const _2 = "._1yt41ejb{padding:var(--ds-space-300,24px)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import EditorSuccessIcon from '@atlaskit/icon/glyph/editor/success';
import { getMyReview } from '@atlassian/mpac-api-client';
import { H6, Stripe } from '@atlassian/mpac-primitives';
import { log } from '@atlassian/mpac-utils';
import React, { useEffect, useState } from 'react';
import { TEST_ID } from '../../../../../../constants';
import { UserReview } from '../UserReview';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _ = "._otyrpxbi{margin-bottom:var(--ds-space-200,1pc)}";
const StyledH6 = forwardRef((_ref, __cmplr) => {
  let {
      as: C = H6,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_otyrpxbi", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  StyledH6.displayName = 'StyledH6';
}
const OwnReviewCard = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt41ejb _2rkooqnp _11q7m7j4 _otyr1jfw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  OwnReviewCard.displayName = 'OwnReviewCard';
}
const OwnReviewInnerCard = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _7, _8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4pxbi _2rko1kwk _11q71j9a _1bsb1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  OwnReviewInnerCard.displayName = 'OwnReviewInnerCard';
}
const OwnReviewSkeleton = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Stripe, {
      width: "15%",
      marginBottom: "var(--ds-space-200, 16px)"
    }), /*#__PURE__*/_jsx(Stripe, {
      height: "13rem",
      marginBottom: "var(--ds-space-500, 40px)"
    })]
  });
};
export const OwnReview = _ref4 => {
  let {
    initialReviewData,
    ownReviewId,
    mpacBaseUrl,
    user,
    appKey,
    loginHref,
    vendorDetails,
    ownReviewUpdated,
    setOwnReviewUpdated,
    filterOutDeletedReview,
    filterOutDeletedVendorResponse,
    hosting,
    onEditReview
  } = _ref4;
  const [reviewData, setReviewData] = useState(initialReviewData);
  const [ownReviewLoading, setOwnReviewLoading] = useState(false);
  useEffect(() => {
    setReviewData(initialReviewData);
  }, [initialReviewData]);
  useEffect(() => {
    if (ownReviewId && !initialReviewData) {
      const getReviewDataById = async () => {
        try {
          const reviewDataResponse = await getMyReview(appKey);
          if (reviewDataResponse) {
            setReviewData(_objectSpread(_objectSpread({}, reviewDataResponse), {}, {
              author: _objectSpread(_objectSpread({}, reviewDataResponse.author), {}, {
                isReviewAuthor: true
              })
            }));
          }
        } catch (error) {
          log.error('getMyReview', 'Error fetching own review data', {
            error
          });
        }
      };
      setOwnReviewLoading(true);
      getReviewDataById();
    }
  }, [appKey, ownReviewId, initialReviewData]);
  useEffect(() => {
    if (reviewData) {
      setOwnReviewLoading(false);
    }
  }, [reviewData]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [ownReviewLoading && /*#__PURE__*/_jsx(OwnReviewSkeleton, {}), reviewData && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FlagGroup, {
        children: ownReviewUpdated && /*#__PURE__*/_jsx(AutoDismissFlag, {
          id: "own-review-updated",
          icon: /*#__PURE__*/_jsx(EditorSuccessIcon, {
            label: "Success",
            primaryColor: "var(--ds-icon-success, #22A06B)"
          }),
          title: "Review updated",
          description: "Your review is updated and will reflect on your profile shortly.",
          onDismissed: () => setOwnReviewUpdated(false),
          actions: [{
            content: 'Got it',
            onClick: () => setOwnReviewUpdated(false)
          }]
        }, 1)
      }), /*#__PURE__*/_jsx(StyledH6, {
        "data-testid": TEST_ID.REVIEWS_TAB_OWN_REVIEW,
        children: "Your Review"
      }), /*#__PURE__*/_jsx(OwnReviewCard, {
        children: /*#__PURE__*/_jsx(OwnReviewInnerCard, {
          children: /*#__PURE__*/_jsx(UserReview, _objectSpread(_objectSpread({
            index: 0,
            isOwnReview: true,
            onEditReview: onEditReview,
            mpacBaseUrl: mpacBaseUrl,
            user: user,
            appKey: appKey,
            filterOutDeletedReview: filterOutDeletedReview,
            filterOutDeletedVendorResponse: filterOutDeletedVendorResponse
          }, reviewData), {}, {
            hosting: hosting,
            loginHref: loginHref,
            vendorDetails: _objectSpread(_objectSpread({}, vendorDetails), reviewData === null || reviewData === void 0 ? void 0 : reviewData.vendor)
          }))
        })
      })]
    })]
  });
};